import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClosingReportPreviewComponent } from './closing-report-preview.component';

const routes: Routes = [
  {
    path: '',
    component: ClosingReportPreviewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ClosingReportPreviewRoutingModule { }
